var SupportCMSModel, SupportDropDownCombinationsModel, SupportDropDownModel;

SupportDropDownModel = require('./dropdowns');

SupportDropDownCombinationsModel = require('./dropdown_combinations');

SupportCMSModel = (function() {
  function SupportCMSModel() {
    this.init(null);
    this.dropDowns = new SupportDropDownModel();
    this.dropDownCombinations = new SupportDropDownCombinationsModel();
  }

  SupportCMSModel.prototype.init = function(currentOrder) {
    this.isCurrentOrderSelected = currentOrder ? true : false;
    window.Groupon.Support.CMS = {
      Category: null,
      SubCategory: null,
      SearchInputIssue: null,
      Content: null
    };
    this.flexibleStepThree = null;
    this.displayStatus = null;
    this.displayNotes = null;
    this.externalDealNotes = null;
    this.isRefundEligible = false;
    return this.escalateToMerchant = false;
  };

  SupportCMSModel.prototype.getContentObject = function() {
    return window.Groupon.Support.CMS;
  };

  SupportCMSModel.prototype.getCategory = function() {
    return Groupon.Support.CMS.Category;
  };

  SupportCMSModel.prototype.getSubCategory = function() {
    return Groupon.Support.CMS.SubCategory;
  };

  SupportCMSModel.prototype.getSearchInputIssue = function() {
    return Groupon.Support.CMS.SearchInputIssue;
  };

  SupportCMSModel.prototype.getContent = function() {
    return Groupon.Support.CMS.Content;
  };

  SupportCMSModel.prototype.getContentId = function() {
    var ref;
    return (ref = Groupon.Support.CMS.Content) != null ? ref.id : void 0;
  };

  SupportCMSModel.prototype.setSubCategory = function(subCategory) {
    return Groupon.Support.CMS.SubCategory = subCategory;
  };

  SupportCMSModel.prototype.setCategory = function(category) {
    return Groupon.Support.CMS.Category = category;
  };

  SupportCMSModel.prototype.setContent = function(content) {
    return Groupon.Support.CMS.Content = content;
  };

  SupportCMSModel.prototype.setSearchInputIssue = function(searchInputIssue) {
    return Groupon.Support.CMS.SearchInputIssue = searchInputIssue;
  };

  SupportCMSModel.prototype.onUnloadStepOne = function() {};

  SupportCMSModel.prototype.onInitStepTwo = function() {};

  SupportCMSModel.prototype.onInitStepThree = function() {};

  SupportCMSModel.prototype.extendParams = function(params) {
    return _.extend(Groupon.Support.CMS, params);
  };

  return SupportCMSModel;

})();

module.exports = SupportCMSModel;

//# sourceMappingURL=data:application/json;base64,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
